var SupportCMSModel, SupportDropDownCombinationsModel, SupportDropDownModel;

SupportDropDownModel = require('./dropdowns');

SupportDropDownCombinationsModel = require('./dropdown_combinations');

SupportCMSModel = (function() {
  function SupportCMSModel() {
    this.init(null);
    this.dropDowns = new SupportDropDownModel();
    this.dropDownCombinations = new SupportDropDownCombinationsModel();
  }

  SupportCMSModel.prototype.init = function(currentOrder) {
    this.isCurrentOrderSelected = currentOrder ? true : false;
    window.Groupon.Support.CMS = {
      Category: null,
      SubCategory: null,
      SearchInputIssue: null,
      Content: null
    };
    this.flexibleStepThree = null;
    this.displayStatus = null;
    this.displayNotes = null;
    this.externalDealNotes = null;
    this.isRefundEligible = false;
    return this.escalateToMerchant = false;
  };

  SupportCMSModel.prototype.getContentObject = function() {
    return window.Groupon.Support.CMS;
  };

  SupportCMSModel.prototype.getCategory = function() {
    return Groupon.Support.CMS.Category;
  };

  SupportCMSModel.prototype.getSubCategory = function() {
    return Groupon.Support.CMS.SubCategory;
  };

  SupportCMSModel.prototype.getSearchInputIssue = function() {
    return Groupon.Support.CMS.SearchInputIssue;
  };

  SupportCMSModel.prototype.getContent = function() {
    return Groupon.Support.CMS.Content;
  };

  SupportCMSModel.prototype.getContentId = function() {
    var ref;
    return (ref = Groupon.Support.CMS.Content) != null ? ref.id : void 0;
  };

  SupportCMSModel.prototype.setSubCategory = function(subCategory) {
    return Groupon.Support.CMS.SubCategory = subCategory;
  };

  SupportCMSModel.prototype.setCategory = function(category) {
    return Groupon.Support.CMS.Category = category;
  };

  SupportCMSModel.prototype.setContent = function(content) {
    return Groupon.Support.CMS.Content = content;
  };

  SupportCMSModel.prototype.setSearchInputIssue = function(searchInputIssue) {
    return Groupon.Support.CMS.SearchInputIssue = searchInputIssue;
  };

  SupportCMSModel.prototype.onUnloadStepOne = function() {};

  SupportCMSModel.prototype.onInitStepTwo = function() {};

  SupportCMSModel.prototype.onInitStepThree = function() {};

  SupportCMSModel.prototype.extendParams = function(params) {
    return _.extend(Groupon.Support.CMS, params);
  };

  return SupportCMSModel;

})();

module.exports = SupportCMSModel;

//# sourceMappingURL=data:application/json;base64,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
